/** @format */

import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import './RoleSelector.css';

@inject('UserStore')
@observer
class Login extends Component {
  state = {
    roles: [
      {
        text: 'Venditore',
        value: 'seller',
      },
      {
        text: 'Magazziniere',
        value: 'warehouse',
      },
    ],
  };
  render() {
    let { UserStore } = this.props;
    return (
      <div className="role-selector">
        <Form size="mini">
          <Form.Group>
            <Form.Select
              id="roleSelect"
              onChange={(e, selection) => UserStore.changeRole(selection)}
              options={this.state.roles}
              label="Scegli ruolo"
              value={UserStore.user.role}
            />
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default Login;
